import React, {useEffect, useState} from 'react'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import Spinner from "reactjs-simple-spinner";
import FilesService from "../../../../../services/FilesService";

const initialUser = {
    policyNumber: "",
    effectiveDate: "",
    identityDocument: "",
}

const AddUserDialog = props => {
    const [user, setUser] = useState(initialUser)
    const {addUserHandler} = props
    const [open, setOpen] = React.useState(false)
    const [loading, setLoading] = useState(false);
    const [successful, setSuccessful] = useState(false);

    const [switchState, setSwitchState] = React.useState({
        addMultiple: false,
    })

    const handleSwitchChange = name => event => {
        setSwitchState({...switchState, [name]: event.target.checked})
    }

    const resetSwitch = () => {
        setSwitchState({addMultiple: false})
    }

    const handleClickOpen = () => {
        setOpen(true)
    }

    const handleClose = () => {
        setOpen(false)
        resetSwitch()
    }

    const handleAdd = event => {
        addUserHandler(user)
        setUser(initialUser)
        switchState.addMultiple ? setOpen(true) : setOpen(false)
    }

    const handleFileChange10 = (e) => {
        setLoading(true);
        console.log(e);
        const file = e.target.files[0];
        let name = e.target.name
        const formData = new FormData();
        formData.append('file', file, file.name);
        FilesService.uploadFile(formData)
            .then(res => {
                console.log(res);
                setLoading(false);
                setSuccessful(true);
                console.log(e.target.name)
                setUser({...user, [name]: res.data.fileName})
            })
            .catch(err => {
                setLoading(false);
                setSuccessful(false);
                console.log(err);
            });
    }

    const handleChange = name => ({target: {value}}) => {
        setUser({...user, [name]: value})
    }

    useEffect(() => {
        setSuccessful(false);
    }, []);


    return (
        <div>
            {/*<Tooltip title="Add New">*/}
            {/*  <span className="btn btn-sm btn-primary mr-5" onClick={handleClickOpen}>*/}
            {/*        <i className="fa fa-plus-square"/> &nbsp;&nbsp;Add New*/}
            {/*    </span>*/}
            {/*</Tooltip>*/}
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title">Matured Policy</DialogTitle>
                <DialogContent>
                    <DialogContentText>Please fill in details</DialogContentText>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Policy Number"
                        type="text"
                        fullWidth
                        value={user.policyNumber}
                        onChange={handleChange('policyNumber')}
                    />
                    <TextField
                        id="date"
                        label="Effective Date"
                        name="Effective Date"
                        type="date"
                        fullWidth
                        onChange={handleChange('effectiveDate')}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        InputProps={{
                            inputProps: {
                                max: ""
                            }
                        }}
                    />


                    <label className="mt-3" htmlFor="inputEmail4">Upload Identity Document</label>
                    <br/>
                    {loading && (
                        <span className="mt-2 mb-2 p-2">
                                        <Spinner
                                            size="small"
                                            message="Uploading File....."
                                            line-fg-color="#64c3c2"
                                        />
                                    </span>
                    )}
                    {!successful && !loading && (
                        <span>
                              <label className="text-muted text-sm-center">* Select File</label>
                            &nbsp;&nbsp;
                            {/*<span style={{display: "none"}} id="uploadingLoader"/>*/}

                            <div className="mt-2">
                        <label className="btn btn-sm btn-primary" htmlFor="identityDocument">
                            <input
                                id="identityDocument"
                                type="file"
                                name="identityDocument"
                                style={{display: "none"}}
                                accept=".pdf, .docx, .doc"
                                onChange={handleFileChange10}
                            />
                            <i className="fa fa-folder-open"/>&nbsp;&nbsp;
                            Browse
                        </label>
                        <div className="p-3"/>
                    </div>
                        </span>
                    )}
                    {successful && (
                        <span>
                              <label className="text-muted text-sm-center">File Saved&nbsp;
                                  <span className="text-success"><i className="fa fa-check"/></span>
                              </label>
                        </span>
                    )}


                </DialogContent>
                <DialogActions>

                    <Button onClick={handleClose} color="primary">
                        Cancel
                    </Button>
                    {successful && (
                        <Button onClick={handleAdd} color="primary">
                            Submit
                        </Button>
                    )}
                </DialogActions>
            </Dialog>
        </div>
    )
}

AddUserDialog.propTypes = {
    addUserHandler: PropTypes.func.isRequired,
}

export default AddUserDialog;
